//jQuery plugins
(function ($) {
    if (!$.isArray) {
        $.isArray = Array.isArray || function (obj) {
            return Object.prototype.toString.call(obj) == '[object Array]';
        };
    }

    $.url = function () { function l(a) { for (var b = "", c = 0, f = 0, d = 0; c < a.length;) { f = a.charCodeAt(c); if (f < 128) { b += String.fromCharCode(f); c++ } else if (f > 191 && f < 224) { d = a.charCodeAt(c + 1); b += String.fromCharCode((f & 31) << 6 | d & 63); c += 2 } else { d = a.charCodeAt(c + 1); c3 = a.charCodeAt(c + 2); b += String.fromCharCode((f & 15) << 12 | (d & 63) << 6 | c3 & 63); c += 3 } } return b } function m(a, b) { var c = {}, f = { "true": true, "false": false, "null": null }; $.each(a.replace(/\+/g, " ").split("&"), function (d, j) { var e = j.split("="); d = k(e[0]); j = c; var i = 0, g = d.split("]["), h = g.length - 1; if (/\[/.test(g[0]) && /\]$/.test(g[h])) { g[h] = g[h].replace(/\]$/, ""); g = g.shift().split("[").concat(g); h = g.length - 1 } else h = 0; if (e.length === 2) { e = k(e[1]); if (b) e = e && !isNaN(e) ? +e : e === "undefined" ? undefined : f[e] !== undefined ? f[e] : e; if (h) for (; i <= h; i++) { d = g[i] === "" ? j.length : g[i]; j = j[d] = i < h ? j[d] || (g[i + 1] && isNaN(g[i + 1]) ? {} : []) : e } else if ($.isArray(c[d])) c[d].push(e); else c[d] = c[d] !== undefined ? [c[d], e] : e } else if (d) c[d] = b ? undefined : "" }); return c } function n(a) { a = a || window.location; var b = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"]; a = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(a); for (var c = {}, f = b.length; f--;) c[b[f]] = a[f] || ""; if (c.query) c.params = m(c.query, true); return c } function o(a) { if (a.source) return encodeURI(a.source); var b = []; if (a.protocol) if (a.protocol == "file") b.push("file:///"); else a.protocol == "mailto" ? b.push("mailto:") : b.push(a.protocol + "://"); if (a.authority) b.push(a.authority); else { if (a.userInfo) b.push(a.userInfo + "@"); else if (a.user) { b.push(a.user); a.password && b.push(":" + a.password); b.push("@") } if (a.host) { b.push(a.host); a.port && b.push(":" + a.port) } } if (a.path) b.push(a.path); else { a.directory && b.push(a.directory); a.file && b.push(a.file) } if (a.query) b.push("?" + a.query); else a.params && b.push("?" + $.param(a.params, true)); a.anchor && b.push("#" + a.anchor); return b.join("") } function p(a) { return encodeURIComponent(a) } function k(a) { a = a || window.location.toString(); return l(unescape(a.replace(/\+/g, " "))) } return { encode: p, decode: k, parse: n, build: o } }();

    $.fn.msg = function (cmd) {
        try {
            if (cmd) {
                var msgArgs = Array.prototype.slice.call(arguments).slice(1);

                this.each(function () {
                    var elem = this;
                    var all = Cortado.Behaviors.allFrom(elem);
                    for (behavior in all) {
                        if (all.hasOwnProperty(behavior)) {	//some idiots like to modify built in object prototypes
                            all[behavior].getInstance(function (instance) {
                                if (cmd in instance && $.isFunction(instance[cmd])) {
                                    instance[cmd].apply(elem, msgArgs);
                                }
                            });
                        }
                    }
                });
            }
        } catch (e) { Cortado.Helpers.log(e.name + ": " + e.message); }
        return this;
    };

    $.fn.broadcast = function (cmd) {
        var origArgs = Array.prototype.slice.call(arguments);
        this.each(function () {
            $('*[data-behavior]', this).andSelf().each(function () {
                $.fn.msg.apply($(this), origArgs);
            });
        });
        return this;
    };

    $.fn.replaceClass = function (old, current) {
        this.removeClass(old).addClass(current);
        return this;
    };

    $.initBehaviorsFor = function (elem) {
        Cortado.Behaviors.parse(elem);
    };

    $.fn.replaceClass = function (old, current) {
        this.removeClass(old).addClass(current);

        return this;
    };

    $.ns = $.namespace = function (namespace) {
        var parts = namespace.split('.');

        var current = window;

        for (var i = 0; i < parts.length; i++) {
            if (!current[parts[i]])
                current[parts[i]] = {};

            current = current[parts[i]];
        }

        return current;
    };

    $.ns('Cortado');

    Cortado.Promise = function () {
        var _state = 'pending';
        var _onResolved = null;
        var _onRejected = null;
        var _arguments = null;

        var notify = function () {
            if (_state == "resolved" && _onResolved) {
                _onResolved.call(this, _arguments);
            }

            if (_state == "rejected" && _onRejected)
                _onRejected.call(this, _arguments);
        };

        var self = {
            then: function (onResolved, onRejected) {
                _onResolved = onResolved;
                _onRejected = onRejected;

                if (_state != 'pending') {	//execute
                    notify();
                }
            },

            resolve: function (data) {
                if (_state == 'pending') {
                    _arguments = data;
                    _state = 'resolved';
                    notify();
                }
            },

            reject: function (data) {
                if (_state == 'pending') {
                    _state = 'rejected';
                    _arguments = data;
                    notify();
                }
            }
        };

        return self;
    };

    Cortado.Uri = function (uriString) {
        var _parsed = $.url.parse(uriString);

        return {
            pieces: function () {
                return _parsed;
            },
            params: function (key, val) {
                if (!_parsed.params)
                    _parsed.params = {};

                if (arguments.length == 0)
                    return _parsed.params;

                if (arguments.length > 1) {
                    //set flow
                    _parsed.params[key] = val;
                }
                else {
                    //get flow
                    return _parsed.params[key];
                }
            },

            toString: function () {
                //wipe source
                _parsed.source = null;
                return $.url.build(_parsed);
            }
        };
    };

    Cortado.ScriptUri = function (uriString) {
        var _baseUri = new Cortado.Uri(uriString);

        return {
            seedValue: function () {
                return _baseUri.params('v');
            }
        };
    };

    Cortado.Behaviors = function () {
        var _autoInit = false;

        var self = {
            parse: function (elem) {
                var typeDef = $(elem).attr('data-behavior');

                if (typeDef) {
                    var types = typeDef.split(' ');

                    for (var i = 0; i < types.length; i++) {
                        var type = types[i];
                        var wrapper = new Cortado.Behaviors.BehaviorWrapper(type, elem);

                        if (!elem.behaviors)
                            elem.behaviors = [];

                        elem.behaviors[type] = wrapper;

                        if ($(elem).attr('data-init') == 'true' || _autoInit)
                            wrapper.touch();
                    }
                }
            },

            wireupEvents: function () {
                if (!window.opera && !/webkit/i.test(navigator.userAgent) && !/Firefox/i.test(navigator.userAgent) && ($.browser.msie && $.browser.version < 9)) return;

                document.addEventListener("DOMContentLoaded", function (event) {
                    $('.extend').each(function () {
                        Cortado.Behaviors.parse(this);
                    });
                }, true);

                document.addEventListener("DOMNodeInserted", function (event) {
                    $('.extend', event.target).andSelf().each(function () {
                        if (/MSIE 10.0/i.test(navigator.userAgent) || /Trident\/7.0/i.test(navigator.userAgent)) {
                            // Temporary fix for IE10 and 11 to prevent mulitple instances of DomNodeInserted from firing.
                            var element = $(this);

                            if (element.attr('data-inserted') !== "true" && element.hasClass('extend')) {
                                Cortado.Behaviors.parse(this);
                                element.attr('data-inserted', 'true');
                            }
                        } else {
                            Cortado.Behaviors.parse(this);
                        }
                    });
                }, true);
            },

            allFrom: function (elem) {
                self.ensure(elem);

                if (!elem.behaviors)
                    return [];

                return elem.behaviors;
            },

            ensure: function (elem) {
                if (!elem.behaviors && $(elem).attr('data-behavior')) {
                    self.parse(elem);
                }
            },

            autoInit: function (enabled) {
                if (enabled != _autoInit && enabled) {
                    $('BODY').broadcast('wakeUp');
                }
                _autoInit = enabled;
            }
        };

        return self;
    }();

    Cortado.Behaviors.BehaviorWrapper = function (typeName, container) {
        var _typeName = typeName;
        var _container = container;
        var _instance = null;
        var _awake = false;

        var wakeUp = function (onInstantiate) {
            Cortado.Bootloader.requireByType(_typeName, function () {
                _instance = eval('new ' + _typeName + '()');

                if ('wakeFrom' in _instance && $.isFunction(_instance['wakeFrom'])) {
                    _instance.wakeFrom(_container);
                }
                _awake = true;
                if ($.isFunction(onInstantiate)) onInstantiate(_instance);
            });
        };

        return {
            getInstance: function (onInstantiate) {
                if (!_awake) {
                    wakeUp(onInstantiate);
                }
                else {
                    onInstantiate(_instance);
                }
            },

            touch: function () {
                if (!_awake) {
                    wakeUp();
                }
            }
        };
    };

    Cortado.Behaviors.wireupEvents();

    Cortado.ErrorManager = function () {
        var ignoreList = [],
            errorQueue = [];

        function init() {
            errorQueue = [];
            window.onerror = function (errorMessage, url, line) {
                logError(errorMessage, 'Unhandled script error at line ' + line + '(' + url + ')');
            };
        }

        function initAjaxHandler() {
            setTimeout(sendErrorsToAjax, 9950);
            window.onbeforeunload = function () { //when browser closed
                sendErrorsToAjax();
            };
        }

        function sendErrorsToAjax() {
            if (errorQueue && errorQueue.length > 0) {
                //Cortado.Helpers.info('Cortado.ErrorManager.sendErrorsToAjax: ' + JSON.stringify(prepareErrorsForAjax()));
                $jq.ajax({
                    type: 'POST',
                    url: '/Site/LogError',
                    contentType: 'application/json; charset=UTF-8',
                    data: JSON.stringify({ errorSummary: prepareErrorsForAjax() })
                });
                errorQueue = [];
            }
        }

        function prepareErrorsForAjax() {
            var params = {
                Errors: errorQueue,
                Path: location.pathname + location.hash
            };
            return params;
        }

        function addToIgnoreList(str) {
            ignoreList.push(str);
        }

        function isInIgnoreList(str) {
            for (var i = 0; i < ignoreList.length; i++) {
                if (str.indexOf(ignoreList[i]) !== -1) return true;
            }
            return false;
        }

        function isDuplicateError(errorMessage, errorDetails) {
            for (var i = 0; i < errorQueue.length; i++) {
                if (errorMessage == errorQueue[i].message) {
                    errorQueue[i].errorCount++;
                    return true;
                }
            }
            return false;
        }

        function logError(errorMessage, details) {
            Cortado.Helpers.error(errorMessage + '\n' + details);

            if (isInIgnoreList(errorMessage) || isDuplicateError(errorMessage, details)) return;

            if (errorQueue.length === 0)
                initAjaxHandler();

            errorQueue.push({
                message: errorMessage,
                details: details,
                errorCount: 1
            });
        }

        return {
            init: init,
            flushErrors: sendErrorsToAjax,
            addToIgnoreList: addToIgnoreList,
            logError: logError
        };
    }();

    Cortado.Bootloader = function () {
        var _loadListeners = [];
        var _allowCache = true;
        var _fetchedByLoader = {};
        var _loadedByLoader = {};

        var determineSeedValue = function () {
            if (!_allowCache)
                return (new Date()).getTime().toString();

            var seedValue = null;
            $('script').each(function () {
                if ($(this).attr('src') && $(this).attr('src').toLowerCase().indexOf('/cortado/bootstrap') >= 0) {
                    var scriptUri = new Cortado.ScriptUri($(this).attr('src'));
                    seedValue = scriptUri.seedValue();
                }
            });

            return seedValue;
        };

        var maskSrc = function (src) {
            return (src.indexOf('~') == 0) ? src.substring(1) : src;
        };
        var maskSrcForFetch = function (src) {
            src = maskSrc(src);
            var uri = new Cortado.Uri(src);
            uri.params('v', determineSeedValue());

            return uri.toString();
        };

        var referenced = function (src) {
            var masked = maskSrc(src).toLowerCase();
            var found = false;

            $('script').each(function () {
                if (this.src && this.src.toLowerCase().indexOf(masked) >= 0) {
                    found = true;
                }
            });

            return found;
        };

        var addListenerFor = function (path, onLoaded) {
            if (_loadListeners[path] == null)
                _loadListeners[path] = [];

            _loadListeners[path][_loadListeners[path].length] = onLoaded;
        };

        var fireAllListenersFor = function (path) {
            if (path in _loadListeners) {
                for (var i = 0; i < _loadListeners[path].length; i++) {
                    if ($.isFunction(_loadListeners[path][i])) _loadListeners[path][i]();
                }
            }
            _loadListeners[path] = [];	//detach listeners
        };

        var getTypeByString = function (typeString) {
            var parts = typeString.split('.');

            var current = window;

            for (var i = 0; i < parts.length; i++) {
                if (!current[parts[i]])
                    return null;

                current = current[parts[i]];
            }

            return current;
        };

        var self = {
            init: function () {
                _allowCache = Cortado.Helpers.querystring().get('caching') != '0';	//default to on
            },
            requireByType: function (typeName, onLoaded) {
                if (getTypeByString(typeName) != null) {
                    onLoaded();
                }
                else {
                    var requirePath = '/scripts/' + typeName.replace('.', '/') + '.js';
                    self.require(requirePath, onLoaded);
                }
            },
            requireBundle: function (src, onLoaded) {
                $.getJSON("/asset-manifest.json", function (data) {
                    if (data[src]) {
                        self.require('/' + data[src].scripts, onLoaded);
                    }
                });
            },
            require: function (src, onLoaded) {
                if ($.isFunction(onLoaded))
                    addListenerFor(src, onLoaded);

                if (referenced(src)) {
                    if (!_fetchedByLoader[src] || _loadedByLoader[src]) {
                        fireAllListenersFor(src);
                    }
                    return;
                }

                _fetchedByLoader[src] = true;

                var script = document.createElement('script');
                script.src = maskSrcForFetch(src);
                script.async = true;
                script.type = 'text/javascript';
                var head = document.getElementsByTagName('head')[0];
                if (!head) {
                    head = document.body.parentNode.appendChild(document.createElement('head'));
                }

                if (script.readyState) { // Ensure IE9 only fires once
                    script.onreadystatechange = function () {
                        if (script.readyState == 'complete' || script.readyState == 'loaded') { // Fire for all versions of IE
                            _loadedByLoader[src] = true;
                            fireAllListenersFor(src);
                        }
                    };
                } else {
                    script.onload = function () {
                        _loadedByLoader[src] = true;
                        fireAllListenersFor(src);
                    };
                }

                head.appendChild(script);
            },
            caching: function (allowCache) {
                _allowCache = allowCache;
            }
        };

        return self;
    }();

    Cortado.Helpers = function () {
        //make calls to console.log safe, lifted from Twitter
        if (!window.console) {
            (function () {
                var names = ["log", "debug", "info", "warn", "error",
                    "assert", "dir", "dirxml", "group", "groupEnd", "time",
                    "timeEnd", "count", "trace", "profile", "profileEnd"],
                    i, l = names.length;

                window.console = {};

                for (i = 0; i < l; i++) {
                    window.console[names[i]] = function () { };
                }
            }());
        }

        if (typeof String.prototype.trim !== 'function') {
            String.prototype.trim = function () {
                return this.replace(/^\s+|\s+$/g, '');
            };
        }

        return {
            safeInvoke: function (method, data) {
                if ($.isFunction(method))
                    method();
            },
            log: function (msg) {
                console.log(msg); //see window.console fix above
            },
            info: function (msg) {
                console.info(msg);
            },
            warn: function (msg) {
                console.warn(msg);
            },
            error: function (msg) {
                console.error(msg);
            },
            array: {
                any: function (arr) {
                    if (arr.length) {
                        return arr.length > 0;
                    }
                    //associative

                    for (var key in arr) {
                        if (arr.hasOwnProperty(key)) {
                            return true;
                        }
                    }

                    return false;
                }
            },

            querystring: function (fromUrl) {
                var _target = "";

                if (arguments.length > 0) {
                    var idx = fromUrl.indexOf('?');
                    if (idx >= 0) {
                        _target = fromUrl.substring(idx); //assumes ? is start character
                    }
                } else {
                    _target = window.location.search;
                }

                return {
                    get: function (name) {
                        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
                        var regexS = "[\\?&]" + name + "=([^&#]*)";
                        var regex = new RegExp(regexS);
                        var results = regex.exec(_target);
                        if (results == null)
                            return "";
                        else
                            return decodeURIComponent(results[1].replace(/\+/g, " "));
                    }
                };
            },
            scaleImage: function (data, img) {
                var Width = (img.width == null) ? 80 : img.width;
                var Height = (img.height == null) ? 100 : img.height;
                var ratio = Math.min(data.width / Width, data.height / Height);

                if (typeof (img) == "object" && img.nodeName == "IMG") {
                    img.width = Math.round(ratio * Width);
                    img.height = Math.round(ratio * Height);
                    return img;
                } else {
                    return {
                        width: Math.round(ratio * Width),
                        height: Math.round(ratio * Height)
                    };
                }
            },
            serializeObject: function (form) {
                var obj = {};
                var values = form.serializeArray();

                for (var i = 0; i < values.length; i++) {
                    obj[values[i].name] = values[i].value;
                }
                return obj;
            },
            isScrolledIntoView: function (element) {
                var docTop = $(window).scrollTop(),
                    docBottom = docTop + $(window).height(),
                    elemTop = $(element).offset().top,
                    elemBottom = elemTop + $(element).height();

                return ((elemTop <= docBottom) && (elemTop >= docTop));
            },

            localStorage: function () {
                if (!window.localStorage) {
                    // Browser does not support localstorage
                    return false;
                }

                return {
                    add: function (key, value) {
                        localStorage[key] = JSON.stringify(value);
                    },

                    remove: function (key) {
                        localStorage.removeItem(key);
                    },

                    getItemByKey: function (key) {
                        if (localStorage[key]) {
                            return JSON.parse(localStorage[key]);
                        }

                        return false;
                    }
                };
            }
        };
    }();

    Cortado.ServiceProxy = function () {
        var request = null;
        var promise = null;

        return {
            invoke: function (data) {
                promise = new Cortado.Promise();

                if (request !== null) {
                    request.abort();
                    request = null;
                }

                var options = {
                    url: '',
                    type: 'json',
                    method: 'get',
                    data: {}
                };

                $.extend(options, data);

                request = $.ajax({
                    url: options.url,
                    dataType: options.type,
                    type: options.method,
                    data: options.data,
                    success: function (response) {
                        promise.resolve(response);
                    },
                    error: function (xmlhttp, status, exception) {
                        promise.reject(xmlhttp);
                    }
                });
                return promise;
            },
            abort: function () {
                if (request !== null) {
                    request.abort();
                    request = null;
                    promise.reject();
                }
            }
        };
    };

    Cortado.ChunkLoader = function () {
        return {
            load: function (data) {
                $.ajax({
                    type: 'GET',
                    cache: false,
                    url: data.url,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-Cortado-ChunkLoad', 'true');

                        if (data.requestHeaders) {
                            for (var key in data.requestHeaders) {
                                if (data.requestHeaders.hasOwnProperty(key)) {
                                    xhr.setRequestHeader(key, data.requestHeaders[key]);
                                }
                            }
                        }
                    },
                    success: function (response, status, xhr) {
                        data.success(response, status, xhr);
                    },
                    error: function (xmlhttp, status, exception) {
                        if (xmlhttp.status == 401) {
                            //for now, login will redirect
                            window.location.href = '/login/login.aspx';
                        } else {
                            data.error(xmlhttp, status, exception);
                        }
                    }
                });

            }
        };
    }();

    Cortado.Session = function () {
        var _service = new Cortado.ServiceProxy(),
            _login = new Cortado.Promise(),
            _modal = null,
            _submitting = false,
            _form = null;

        var login = function () {
            var data = _form.serialize();
            var errors = $('.errors', _form);

            if (_submitting) return;
            _submitting = true;

            _form.msg('busy', true);
            errors.hide();

            $.ajax({
                type: "GET",
                url: '/Membership/EnsureSession/',
                success: function () {
                    // INCEPTION! WE NEED TO GO DEEPER! 
                    $.ajax({
                        url: '/Membership/Login/',
                        type: "POST",
                        data: data,
                        dataType: "json",
                        success: function (response) {
                            if (response.hasOwnProperty('success')) {
                                if (!response.success) {
                                    var message = response.reason;

                                    errors.html(message).show();

                                    _form.msg('busy', false);
                                    _submitting = false;

                                    return false;
                                }

                                if (response.uid !== undefined) {
                                    //compare previous uid to logged in
                                    var uid = $('#cuid');
                                    var oldUid = (uid.val().length > 0) ? parseInt(uid.val()) : 0;

                                    if (parseInt(response.uid) != oldUid) {
                                        //refresh the page
                                        window.location.reload(true);
                                        return false;
                                    }
                                }

                                _login.resolve();

                                if (_modal !== null) {
                                    _modal.msg('dismiss');
                                }
                            }

                            _login.reject();
                        },
                        error: function () {
                            console.log('Failed to login via /membership/login/');
                            _login.reject();
                        }
                    });
                }
            });
        };

        var ensureLogin = function () {
            // Return service promise
            return _service.invoke({
                url: '/Membership/IsLoggedIn/',
                type: '',
                method: 'GET'
            });
        };

        var getLoginPanel = function (callback) {
            Cortado.ChunkLoader.load({
                url: '/Membership/LoginPanel/',
                success: function (response) {
                    callback(response);
                },
                error: function () {
                    console.log('failed to get login panel');
                }
            });
        };

        var clearForm = function (container) {
            _form = $('form', container);
            _form.msg('busy', false).get(0).reset();
            $('.errors', container).hide();
        };

        var wireUpEvents = function (container) {
            clearForm(container);

            container.off().on('click', '.login_confirm', function (e) {
                e.preventDefault();
                login();
            }).on('keypress', 'form', function (e) {
                if (e.which == 13) {
                    login();
                }
            }).on('click', '.prompt_dismiss', function () {
                _modal.msg('dismiss');
                _login.reject({ 'Success': false, 'Reason': 'UserAbandon' });
            });
        };

        var insertDialog = function () {
            var dialog = '<div class="dialog dialog-login extend" id="sessionLogin" data-behavior="Cortado.dialog Cortado.refreshable" data-refresh="/Membership/LoginPanel/" data-init="true" data-autoload="true"></div>';
            var count = 5;
            var promise = new Cortado.Promise();

            // Prevent duplicates then check if dialog is inserted before resolving promise.
            var getDialog = window.setInterval(function () {
                _modal = $('#sessionLogin');

                if (_modal.length < 1) {
                    $('body').append(dialog);
                }

                if (_modal.length > 0) {
                    clearInterval(getDialog);

                    if (_modal[0].style.display == 'none') {
                        _modal.msg('show');
                    }

                    promise.resolve();
                }

                if (_modal.length == 0 && count == 0) {
                    clearInterval(getDialog);
                    promise.reject();
                }

                count--;
            }, 500);

            return promise;
        };

        return {
            ensureLoggedIn: function () {
                return ensureLogin();
            },

            loginBy: {
                dialog: function () {
                    insertDialog().then(function () {
                        wireUpEvents(_modal);
                    });
                    return _login;
                },

                panel: function (container) {
                    getLoginPanel(function (response) {
                        container.html(response);
                        wireUpEvents(container);
                    });

                    return _login;
                }
            }
        };
    };

    Cortado.Facebook = function () {
        $.ns('Facebook');

        return {
            connect: function (context) {
                Cortado.Bootloader.require('/scripts/facebook/connect.js', function () {
                    if (context) {
                        Facebook.Controller.Connect(context);
                    } else {
                        Facebook.Controller.Load();
                    }
                });
            }
        };
    }();

    Cortado.Advertising = function () {
        var cache = [];
        var serviceEnabled = false;
        var slots = {};
        var calledAmzn = false;
        var PREBID_WAIT = 700;
        var _timeout = setTimeout(function () { }, PREBID_WAIT);

        function publishAdUnit(ad) {

            var protocol = document.location.protocol;

            Cortado.Bootloader.require('/scripts/prebid/prebid_20170816.js', function () {

                Cortado.Bootloader.require(protocol + "//match-d.openx.net/w/1.0/jstag?nc=7214-Match", function () {

                    Cortado.Bootloader.require(protocol + "//c.amazon-adsystem.com/aax2/amzn_ads.js", function () {

                        Cortado.Bootloader.require(protocol + "//www.googletagservices.com/tag/js/gpt.js", function () {
                            var value,
                                values;

                            // API documentation https://developers.google.com/doubleclick-gpt/reference
                            googletag.cmd.push(function () {

                                //we need to wait for bids to come back, refresh gets called by header bidder!
                                googletag.pubads().disableInitialLoad();
                                var adUnit;

                                if (slots[ad.id]) {

                                    if (calledAmzn == false) {
                                        amznads.getAdsCallback('3121', function () {
                                            try {
                                                amznads.setTargetingForGPTAsync('amznslots');
                                            } catch (e) { /*ignore*/
                                            }

                                        });
                                        calledAmzn = true;
                                    }
                                    // googletag.pubads().clearTargeting('amznslots');
                                    googletag.pubads().refresh([slots[ad.id]]);
                                    console.log('called refresh...');

                                    return;
                                }

                                if (ad.isOutOfPageSlot) {
                                    slots[ad.id] = googletag.defineOutOfPageSlot(ad.path, ad.id).setTargeting('ad_group', adomikRandomGroup());
                                    adUnit = slots[ad.id].addService(googletag.pubads());
                                } else {
                                    slots[ad.id] = googletag.defineSlot(ad.path, ad.adSize, ad.id).setTargeting('ad_group', adomikRandomGroup());
                                    adUnit = slots[ad.id].addService(googletag.pubads());
                                }

                                for (key in ad.targeting) {
                                    value = ad.targeting[key];
                                    values = value.split(",");

                                    // Determine if key has multiple values
                                    if (values.length > 1) {
                                        // Key with multiple values
                                        adUnit.setTargeting(key, values);
                                    } else {
                                        // Key with single value
                                        adUnit.setTargeting(key, value);
                                    }
                                }

                                // Fire once per page life cycle.
                                if (serviceEnabled === false) {
                                    serviceEnabled = true;

                                    if (window.Krux !== undefined) {
                                        googletag.pubads().setTargeting("ksg", Krux.segments);
                                        googletag.pubads().setTargeting("kuid", Krux.user);
                                    }

                                    googletag.pubads().enableAsyncRendering();
                                    googletag.enableServices();
                                }

                                // Render ad placement
                                if (calledAmzn == false) {
                                    amznads.getAdsCallback('3121', function () {
                                        try {
                                            amznads.setTargetingForGPTAsync('amznslots');
                                        } catch (e) { /*ignore*/
                                        }
                                        calledAmzn = false;
                                    });
                                    calledAmzn = true;
                                    googletag.display(ad.id);
                                } else {
                                    googletag.display(ad.id);
                                }
                            });

                            //let's kick off the prebid process here?
                            Cortado.Bootloader.require('/scripts/cortado/header-bidder.js', function () {
                                var headerBidder = Cortado.HeaderBidder();
                                headerBidder.createAdUnit(ad);
                                _timeout = headerBidder.resetTimeout(_timeout, headerBidder.requestBids, PREBID_WAIT);

                            });
                        });
                    });
                });
            });

        }

        function adomikRandomGroup() {
            var rand = Math.random();
            switch (false) {
                case !(rand < 0.09): return "ad_ex" + (Math.floor(100 * rand));
                case !(rand < 0.10): return "ad_bc";
                default: return "ad_opt";
            }
        }

        function eas_load(ad) {
            var scriptSrc = ad.scriptSrc();
            var element = document.getElementById(ad.id);

            if (element == null) {
                return;
            }
            element.innerHTML = '';

            EAS_load_fif(ad.id, "/ads/matchAdsIframe.htm", scriptSrc, ad.adwidth, ad.adheight);
        }

        var refresh = function (ad) {

            Cortado.Bootloader.require('/scripts/EAS_Tag.1.0.js', function () {
                try {
                    if (typeof (EAS_load_fif) == "function") {
                        if (ad.version && ad.version === 2) {
                            // New hotness
                            publishAdUnit(ad);
                        } else {
                            // Legacy ad method
                            eas_load(ad);
                        }
                    }
                } catch (error) {
                    console.log(ad.id + ' failed to load');
                    console.log(error);
                }
            });
        };

        return {
            add: function (placement) {
                var key = placement.id;
                cache[key] = placement;

                if (placement.autoLoad === true) {
                    refresh(placement);
                }
                return this;
            },

            load: function (placements) {
                if ($.isArray(placements)) {
                    for (var i = 0; i < placements.length; i++) {
                        if (cache[placements[i]]) {
                            refresh(cache[placements[i]]);
                        }
                    }
                } else {
                    if (cache[placements]) {
                        refresh(cache[placements]);
                    }
                }
            },

            loadAll: function (byZone) {
                for (var key in cache) {
                    if (byZone) {
                        if (cache[key].adzone === byZone) {
                            refresh(cache[key]);
                        }
                    } else {
                        refresh(cache[key]);
                    }
                }
            },

            info: function () {
                return cache;
            },

            allowAmznCall: function () {
                calledAmzn = false;
            }
        };
    }();

    Cortado.Bootloader.init();

    /* IE-specific shims to work around bugs in MS Internet Explorer */
    //167532: bug fix for IE where img element nested within a label does not fire the click event of the label's associated control.
    // Only apply gobal handler on pages using updated version of jQuery
    if ($.browser.msie && $.fn.jquery !== '1.2.6') {
        $(document).on("click", "label>img", function (e) {
            e.preventDefault();
            var label = $(this).parent();
            if (label.attr("for")) {
                $("#" + label.attr("for")).click();
            } else {
                label.find("input,select,button").first().click();
            }
        });

        if (!Date.prototype.toISOString) {
            (function () {
                function pad(number) {
                    if (number < 10) {
                        return '0' + number;
                    }
                    return number;
                }

                Date.prototype.toISOString = function () {
                    return this.getUTCFullYear() +
                        '-' + pad(this.getUTCMonth() + 1) +
                        '-' + pad(this.getUTCDate()) +
                        'T' + pad(this.getUTCHours()) +
                        ':' + pad(this.getUTCMinutes()) +
                        ':' + pad(this.getUTCSeconds()) +
                        '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
                        'Z';
                };
            }());
        }
    }
    /* End of IE-specific shims*/
})(jQuery);